import React from "react";
import { withStyles } from "@material-ui/core/styles";
import MobileOffIcon from "@material-ui/icons/MobileOff";
import Tooltip from "../../../../../../common/StyledToolTip";
import { SHOW_DRIVER_LOGGED_STATUS } from "../../../constants";
const styles = (theme) => ({
  root: {
    paddingTop: "8px",
  },
  icon: {
    fontSize: "12px",
    color: theme.rowViolationDotColor,
  },
});

const LogoutStatusIndicator = (params) => {
  const { classes } = params;
  return (
    <div className={classes.root}>
      <Tooltip title={`Driver ${SHOW_DRIVER_LOGGED_STATUS.loggedOut}`}>
        <MobileOffIcon className={classes.icon} />
      </Tooltip>
    </div>
  );
};

export default withStyles(styles)(LogoutStatusIndicator);
